/**
 * Junkyard
 *
 * @author <bas.jsdev@gmail.com>
 */


'use strict';


var tools = {
    /**
     * global flag to prevent ajax queries
     */
    ajaxStop: false,
    /**
     * Ajax request
     * @param {string} method "post", "get" or "head"
     * @param {string} url address
     * @param {function} callback on
     * @param {Object} [headers] list of optional headers like "charset", "Content-Type" and so on
     * @param {string} [type=text] data parsing mode: plain text (default), xml, json
     * @param {boolean} [async=true] send asynchronous request
     * @return {XMLHttpRequest} request object in case response headers are necessary
     * @example
     *   ajax('get', 'https://google.com/', function(data, status){console.info(data, status);}, {charset:'utf-8'})
     */
    ajax: function ( method, url, callback, headers, type, async ) {
        var hname,
            jdata   = null,
            timeout = null,
            xhr     = new XMLHttpRequest();

        async = async !== false;
        xhr.onreadystatechange = function () {
            var respText;

            if ( xhr.readyState === 4 ) {
                clearTimeout(timeout);
                if ( tools.ajaxStop ) {
                    //echo(xhr.status, title);
                    if ( typeof callback === 'function' ) { callback(null, null, null); }
                } else {
                    //echo('status:' + xhr.status + ', length:' + xhr.responseText.length, title);
                    //echo(xhr.responseText, title);
                    if ( type === 'json' && xhr.status === 200 ) {
                        try {
                            jdata = JSON.parse(xhr.responseText);
                        } catch ( error ) {
                            //echo(e, 'AJAX JSON.parse');
                            jdata = null;
                        }
                    }
                    if ( typeof callback === 'function' ) {
                        if ( type === 'xml' ) {
                            respText = xhr.responseXML;
                        } else {
                            respText = (type === 'json' ? jdata : xhr.responseText);
                        }

                        callback(respText, xhr.status, xhr);
                    }
                }
            }
        };
        xhr.open(method, url, async);
        // set headers if present
        if ( headers ) {
            for ( hname in headers ) {
                if ( headers.hasOwnProperty(hname) ) {
                    xhr.setRequestHeader(hname, headers[hname]);
                }
            }
        }
        xhr.send();
        //echo('sent', title);
        // abort after some time (60s)
        timeout = setTimeout(function () {
            xhr.abort();
            //echo('ABORT on timeout', title);
            if ( typeof callback === 'function' ) {
                callback(null, 0);
            }
        }, 60000);

        return xhr;
    },
    /**
     * Parse date string and return date without time zone
     * @param {string} dateStr date string in EST or UTC format
     */
    timeZoneOffsets: {
        A: {index: -1, minutes: 60},
        ACDT: {index: -1, minutes: 60},
        ACST: {index: -1, minutes: 570},
        ACT: {index: 1, minutes: 300},
        ACWST: {index: -1, minutes: 525},
        ADT: {index: 1, minutes: 180},
        AEDT: {index: -1, minutes: 61},
        AEST: {index: -1, minutes: 60},
        AFT: {index: -1, minutes: 270},
        AKDT: {index: 1, minutes: 480},
        AKST: {index: 1, minutes: 540},
        ALMT: {index: -1, minutes: 360},
        AMST: {index: 1, minutes: 180},
        AMT: {index: 1, minutes: 240},
        ANAST: {index: -1, minutes: 62},
        ANAT: {index: -1, minutes: 62},
        AQTT: {index: -1, minutes: 300},
        ART: {index: 1, minutes: 180},
        AST: {index: 1, minutes: 240},
        AWDT: {index: -1, minutes: 540},
        AWST: {index: -1, minutes: 480},
        AZOST: {index: 0, minutes: 0},
        AZOT: {index: 1, minutes: 60},
        AZST: {index: -1, minutes: 300},
        AZT: {index: -1, minutes: 240},
        B: {index: -1, minutes: 120},
        BNT: {index: -1, minutes: 480},
        BOT: {index: 1, minutes: 240},
        BRST: {index: 1, minutes: 120},
        BRT: {index: 1, minutes: 180},
        BST: {index: -1, minutes: 60},
        BTT: {index: -1, minutes: 360},
        C: {index: -1, minutes: 180},
        CAST: {index: -1, minutes: 480},
        CAT: {index: -1, minutes: 120},
        CCT: {index: -1, minutes: 390},
        CDT: {index: 1, minutes: 300},
        CEST: {index: -1, minutes: 120},
        CET: {index: -1, minutes: 60},
        CHADT: {index: -1, minutes: 63},
        CHAST: {index: -1, minutes: 62},
        CHOT: {index: -1, minutes: 480},
        CHUT: {index: -1, minutes: 600},
        CKT: {index: 1, minutes: 60},
        CLST: {index: 1, minutes: 180},
        CLT: {index: 1, minutes: 240},
        COT: {index: 1, minutes: 300},
        CST: {index: 1, minutes: 360},
        CVT: {index: 1, minutes: 60},
        CXT: {index: -1, minutes: 420},
        ChST: {index: -1, minutes: 60},
        D: {index: -1, minutes: 240},
        DAVT: {index: -1, minutes: 420},
        E: {index: -1, minutes: 300},
        EASST: {index: 1, minutes: 300},
        EAST: {index: 1, minutes: 360},
        EAT: {index: -1, minutes: 180},
        ECT: {index: 1, minutes: 300},
        EDT: {index: -1, minutes: 61},
        EEST: {index: -1, minutes: 180},
        EET: {index: -1, minutes: 120},
        EGST: {index: 0, minutes: 0},
        EGT: {index: 1, minutes: 60},
        EST: {index: 1, minutes: 300},
        ET: {index: 1, minutes: 300},
        F: {index: -1, minutes: 360},
        FET: {index: -1, minutes: 180},
        FJST: {index: -1, minutes: 63},
        FJT: {index: -1, minutes: 62},
        FKST: {index: 1, minutes: 180},
        FKT: {index: 1, minutes: 240},
        FNT: {index: 1, minutes: 120},
        G: {index: -1, minutes: 420},
        GALT: {index: 1, minutes: 360},
        GAMT: {index: 1, minutes: 540},
        GET: {index: -1, minutes: 240},
        GFT: {index: 1, minutes: 180},
        GILT: {index: -1, minutes: 62},
        GMT: {index: 0, minutes: 0},
        GST: {index: -1, minutes: 240},
        GYT: {index: 1, minutes: 240},
        H: {index: -1, minutes: 480},
        HAA: {index: 1, minutes: 180},
        HAC: {index: 1, minutes: 300},
        HADT: {index: 1, minutes: 540},
        HAE: {index: 1, minutes: 240},
        HAP: {index: 1, minutes: 420},
        HAR: {index: 1, minutes: 360},
        HAST: {index: 1, minutes: 60},
        HAT: {index: 1, minutes: 150},
        HAY: {index: 1, minutes: 480},
        HKT: {index: -1, minutes: 480},
        HLV: {index: 1, minutes: 270},
        HNA: {index: 1, minutes: 240},
        HNC: {index: 1, minutes: 360},
        HNE: {index: 1, minutes: 300},
        HNP: {index: 1, minutes: 480},
        HNR: {index: 1, minutes: 420},
        HNT: {index: 1, minutes: 210},
        HNY: {index: 1, minutes: 540},
        HOVT: {index: -1, minutes: 420},
        I: {index: -1, minutes: 540},
        ICT: {index: -1, minutes: 420},
        IDT: {index: -1, minutes: 180},
        IOT: {index: -1, minutes: 360},
        IRDT: {index: -1, minutes: 270},
        IRKST: {index: -1, minutes: 540},
        IRKT: {index: -1, minutes: 540},
        IRST: {index: -1, minutes: 210},
        IST: {index: -1, minutes: 60},
        JST: {index: -1, minutes: 540},
        K: {index: -1, minutes: 60},
        KGT: {index: -1, minutes: 360},
        KOST: {index: -1, minutes: 660},
        KRAST: {index: -1, minutes: 480},
        KRAT: {index: -1, minutes: 480},
        KST: {index: -1, minutes: 540},
        KUYT: {index: -1, minutes: 240},
        L: {index: -1, minutes: 61},
        LHDT: {index: -1, minutes: 61},
        LHST: {index: -1, minutes: 60},
        LINT: {index: -1, minutes: 64},
        M: {index: -1, minutes: 62},
        MAGST: {index: -1, minutes: 62},
        MAGT: {index: -1, minutes: 62},
        MART: {index: 1, minutes: 570},
        MAWT: {index: -1, minutes: 300},
        MDT: {index: 1, minutes: 360},
        MESZ: {index: -1, minutes: 120},
        MEZ: {index: -1, minutes: 60},
        MHT: {index: -1, minutes: 62},
        MMT: {index: -1, minutes: 390},
        MSD: {index: -1, minutes: 240},
        MSK: {index: -1, minutes: 240},
        MST: {index: 1, minutes: 420},
        MUT: {index: -1, minutes: 240},
        MVT: {index: -1, minutes: 300},
        MYT: {index: -1, minutes: 480},
        N: {index: 1, minutes: 60},
        NCT: {index: -1, minutes: 61},
        NDT: {index: 1, minutes: 150},
        NFT: {index: -1, minutes: 61},
        NOVST: {index: -1, minutes: 420},
        NOVT: {index: -1, minutes: 360},
        NPT: {index: -1, minutes: 345},
        NRT: {index: -1, minutes: 720},
        NST: {index: 1, minutes: 210},
        NUT: {index: 1, minutes: 61},
        NZDT: {index: -1, minutes: 63},
        NZST: {index: -1, minutes: 62},
        O: {index: 1, minutes: 120},
        OMSST: {index: -1, minutes: 420},
        OMST: {index: -1, minutes: 420},
        ORAT: {index: -1, minutes: 300},
        P: {index: 1, minutes: 180},
        PDT: {index: 1, minutes: 420},
        PET: {index: 1, minutes: 300},
        PETST: {index: -1, minutes: 62},
        PETT: {index: -1, minutes: 62},
        PGT: {index: -1, minutes: 60},
        PHOT: {index: -1, minutes: 63},
        PHT: {index: -1, minutes: 480},
        PKT: {index: -1, minutes: 300},
        PMDT: {index: 1, minutes: 120},
        PMST: {index: 1, minutes: 180},
        PONT: {index: -1, minutes: 61},
        PST: {index: 1, minutes: 480},
        PT: {index: 1, minutes: 480},
        PWT: {index: -1, minutes: 540},
        PYST: {index: 1, minutes: 180},
        PYT: {index: 1, minutes: 240},
        Q: {index: 1, minutes: 240},
        QYZT: {index: 1, minutes: 360},
        R: {index: 1, minutes: 300},
        RET: {index: -1, minutes: 240},
        S: {index: 1, minutes: 360},
        SAKT: {index: 1, minutes: 600},
        SAMT: {index: -1, minutes: 240},
        SAST: {index: -1, minutes: 120},
        SBT: {index: -1, minutes: 61},
        SCT: {index: -1, minutes: 240},
        SGT: {index: -1, minutes: 480},
        SRET: {index: -1, minutes: 660},
        SRT: {index: 1, minutes: 180},
        SST: {index: 1, minutes: 61},
        T: {index: 1, minutes: 420},
        TAHT: {index: 1, minutes: 60},
        TFT: {index: -1, minutes: 300},
        TJT: {index: -1, minutes: 300},
        TKT: {index: -1, minutes: 63},
        TLT: {index: -1, minutes: 540},
        TMT: {index: -1, minutes: 300},
        TOT: {index: -1, minutes: 780},
        TVT: {index: -1, minutes: 62},
        U: {index: 1, minutes: 480},
        ULAT: {index: -1, minutes: 480},
        UTC: {index: 0, minutes: 0},
        UYST: {index: 1, minutes: 120},
        UYT: {index: 1, minutes: 180},
        UZT: {index: -1, minutes: 300},
        V: {index: 1, minutes: 540},
        VET: {index: 1, minutes: 270},
        VLAST: {index: -1, minutes: 61},
        VLAT: {index: -1, minutes: 61},
        VUT: {index: -1, minutes: 61},
        W: {index: 1, minutes: 60},
        WARST: {index: 1, minutes: 180},
        WAST: {index: -1, minutes: 120},
        WAT: {index: -1, minutes: 60},
        WEST: {index: -1, minutes: 60},
        WESZ: {index: -1, minutes: 60},
        WET: {index: 0, minutes: 0},
        WEZ: {index: 0, minutes: 0},
        WFT: {index: -1, minutes: 62},
        WGST: {index: 1, minutes: 120},
        WGT: {index: 1, minutes: 180},
        WIB: {index: -1, minutes: 420},
        WIT: {index: -1, minutes: 540},
        WITA: {index: -1, minutes: 480},
        WST: {index: -1, minutes: 63},
        WT: {index: 0, minutes: 0},
        X: {index: 1, minutes: 61},
        Y: {index: 1, minutes: 62},
        YAKST: {index: -1, minutes: 60},
        YAKT: {index: -1, minutes: 60},
        YAPT: {index: -1, minutes: 60},
        YEKST: {index: -1, minutes: 360},
        YEKT: {index: -1, minutes: 360},
        Z: {index: 0, minutes: 0}
    },
    /**
     * Parse date string. Use it to convert from gstb image custom date format to js Date object.
     *
     * @param {string} date normal string date or image string date (Mon Feb 27 16:50:14 EET 2017)
     *
     * @return {Date} date object
     */
    toDate: function ( date ) {
        var result, timeZone, offset;

        if ( date ) {
            // normal date format
            result = new Date('' + date);
            // image date format
            if ( isNaN(result.getTime()) ) {
                try {
                    result = new Date(date.match(/\w{3}\s\w{3}\s\d{1,2}\s\d{1,2}:\d{1,2}:\d{1,2}/) + ' ' + date.match(/\d{4}/));
                    timeZone = date.match(/(\w{1,4})\s+\d{4}/)[1];
                    offset = tools.timeZoneOffsets[timeZone];

                    if ( offset.index !== 0 ) {
                        result.setMinutes(result.getMinutes() + ((offset.minutes || 0) * offset.index) - result.getTimezoneOffset());
                    }
                } catch ( error ) {
                    console.log('can\'t parse firmware image date: ' + date);
                    result = new Date(NaN);
                }
            }
        } else {
            result = new Date(NaN);
        }

        return result;
    },
    /**
     * URL parsing tool
     * (c) Steven Levithan <stevenlevithan.com>
     * MIT License
     *
     * @param {string} str url to parse
     *
     * @return {{}} parsed structure
     */
    parseUri: function ( str ) {
        var opts = tools.parseUri.options,
            mode = opts.parser[opts.strictMode ? 'strict' : 'loose'].exec(str),
            uri  = {},
            indx = 14;

        while ( indx-- ) { uri[opts.key[indx]] = mode[indx] || ''; }

        uri[opts.q.name] = {};
        uri[opts.key[12]].replace(opts.q.parser, function ( $0, $1, $2 ) {
            if ( $1 ) { uri[opts.q.name][$1] = $2; }
        });

        return uri;
    }
};

tools.parseUri.options = {
    strictMode: false,
    key: [
        'source',
        'protocol',
        'authority',
        'userInfo',
        'user',
        'password',
        'host',
        'port',
        'relative',
        'path',
        'directory',
        'file',
        'query',
        'anchor'
    ],
    q: {
        name: 'queryKey',
        parser: /(?:^|&)([^&=]*)=?([^&]*)/g
    },
    parser: {
        /* eslint-disable */
        strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
        loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
        /* eslint-enable */
    }
};

// public
module.exports = tools;
